<template>
  <div>
    <el-select
      v-model="value"
      :placeholder="placeholder"
      :disabled="isDisabled"
      @change="changeVal"
    >
      <el-option
        v-for="item in options"
        :key="item.codeId"
        :label="item.codeName"
        :value="item.codeName"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { codeType } from '../api/common'
export default {
  props: {
    typeCode: {
      // 查询的字典值
      type: String,
      default: ''
    },
    code: {
      // 选中的那一项的key
 
      required: true
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    extraInfo: {
      type: Object
    }
  },
  data() {
    return {
      value: '',
      options: []
    }
  },
  watch: {
    code: function (newVal) {
      this.value = newVal
    },

    value: function (newVal) {
      this.$emit('update:code', newVal)
    }
  },

  created() {
    this.getDicData()
  },

  methods: {
    async getDicData() {
      this.options = sessionStorage.getItem(this.typeCode)

      if (!this.options) {
        const { data: res } = await codeType({
          code: this.typeCode
        })

        sessionStorage.setItem(this.typeCode, JSON.stringify(res.data))
      }

      this.options = JSON.parse(sessionStorage.getItem(this.typeCode))

      if (this.code) {
        this.options.forEach((item) => {
          if (item.codeName === this.code) {
            this.value = item.codeName
          }
        })
      }
    },
    changeVal() {
      this.$emit('changeVal', this.value, this.extraInfo)
    }
  }
}
</script>
